import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { ROUTES } from "./constants/routes";
import { EXPECTED_LOGIN_ROLE } from "./reducer-store/constants";

type StateProps = {
  auth: AuthProps;
};

type AuthProps = {
  isAuthenticated: string | boolean;
  isVerified: string | boolean;
  token: string;
  user?: { role_id?: number | string } | null;
};

type RouteProps = {
  Component: any;
  path: string;
  exact?: boolean;
  restricted?: boolean;
};

const hasAllowedRole = (user?: AuthProps["user"]) => {
  if (!user) return true;
  return Number(user.role_id) === EXPECTED_LOGIN_ROLE;
};

export const PrivateRoute: React.FC<RouteProps> = ({
  Component,
  path,
  exact,
}) => {
  const auth: AuthProps = useSelector((state: StateProps) => state.auth);
  const { isAuthenticated, isVerified, user } = auth;
  const allowed = Boolean(isAuthenticated && isVerified && hasAllowedRole(user));
  return (
    <Route
      exact
      path={path}
      render={(props: any) =>
        allowed ? (
          <Component {...props} />
        ) : (
          <Redirect to={ROUTES.login} />
        )
      }
    />
  );
};

export const PublicRoute: React.FC<RouteProps> = ({
  Component,
  path,
  restricted,
  exact,
}) => {
  const auth: AuthProps = useSelector((state: StateProps) => state.auth);
  const { isAuthenticated, isVerified, user } = auth;
  const allowed = Boolean(isAuthenticated && isVerified && hasAllowedRole(user));
  return (
    <Route
      exact
      path={path}
      render={(props: any) =>
        allowed && restricted ? (
          <Redirect to={ROUTES.dashboard} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};
